module.exports = __webpack_public_path__ + "static/media/analimat.020b6e5d.JPG";